/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThreatVulnerabilitiesFiltersRequestSortCriteria {
    getFixupPrototypeFunction() { return ThreatVulnerabilitiesFiltersRequestSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<ThreatVulnerabilitiesFiltersRequestSortCriteria>): ThreatVulnerabilitiesFiltersRequestSortCriteria {
        let obj = Object.assign(new ThreatVulnerabilitiesFiltersRequestSortCriteria(), model);
        ThreatVulnerabilitiesFiltersRequestSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThreatVulnerabilitiesFiltersRequestSortCriteria>): ThreatVulnerabilitiesFiltersRequestSortCriteria {
        if (!model) return null;
        return ThreatVulnerabilitiesFiltersRequestSortCriteria.newInstance(<ThreatVulnerabilitiesFiltersRequestSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThreatVulnerabilitiesFiltersRequestSortCriteria) {
        if (!obj) return;

        models.ThreatVulnerabilitiesFiltersRequestSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThreatVulnerabilitiesFiltersRequestSortCriteria): boolean {
        Object.setPrototypeOf(obj, ThreatVulnerabilitiesFiltersRequestSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.ThreatVulnerabilitiesFiltersRequestSortColumn;

    ascending: boolean;

}
